<template>
  <el-dialog
    class="publicvenue-edit"
    title="修改场馆信息"
    :visible="dialogFormVisible"
    width="750px"
    center
    :close-on-click-modal="false"
    @open="dialogOpen"
    @close="dialogClose"
  >
    <el-descriptions
      class="margin-top"
      title=""
      :column="2"
      border
      direction="horizontal"
    >
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user"></i>
          场馆名字
        </template>
        <el-input v-model="ruleForm.venueName" placeholder="请输入内容"></el-input>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-postcard"></i>
          场馆状态
        </template>
        <el-select v-model="ruleForm.status" placeholder="请选择">
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions class="margin-top" title="" :column="1" border direction="vertical">
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-tickets"></i>
          场馆备注
        </template>
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入内容"
          v-model="ruleForm.venueRemark"
        >
        </el-input>
      </el-descriptions-item>
    </el-descriptions>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "",
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false,
    },
    publicvenueData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  inject: ["refresh"],
  data() {
    return {
      statusList: [
        {
          label: "正常",
          value: "0",
        },
        {
          label: "停用",
          value: "1",
        },
      ],
      ruleForm: {
        id: "",
        venueName: "",
        venueRemark: "",
        status: "",
      },
    };
  },
  mounted() {},
  methods: {
    dialogOpen() {
      let { id, venueName, venueRemark, status } = this.publicvenueData;
      this.ruleForm = { id, venueName, venueRemark, status };
    },
    dialogClose() {
      this.$emit("update:dialogFormVisible", false);
    },
    confirm() {
      let { id, venueName, venueRemark, status } = this.ruleForm;
      let data = {
        id,
        venueName,
        venueRemark,
        schoolId: this.user.schoolId,
        status, // 场馆状态  1正常，1停用 不传默认正常，停用的场馆不可以被预约
      };
      this.put(this.$url.editPublicvenue, data).then((res) => {
        // console.log("修改场馆返回==>", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success("修改成功");
        // 刷新列表
        this.refresh();
        // 关闭弹出框
        this.dialogClose();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./publicvenueEdit.scss";
</style>
